import { convertToCSV, downloadFile } from './helpers';
import type { IOrder, IOrderWithSource } from 'types/order';

export const downloadOrdersCSV = (
  orders: (IOrder | IOrderWithSource)[],
  fileName: string
): void => {
  const csvContent = generateOrdersCSV(orders);
  downloadFile({
    content: csvContent,
    fileName,
    type: 'text/csv;charset=utf-8;',
  });
};

function generateOrdersCSV(orders: (IOrder | IOrderWithSource)[]): string {
  const headers = [
    'ID Zamówienia',
    'Data utworzenia',
    'Status',
    'Kod potwierdzenia',
    'Restauracja',
    'Klient - Imię',
    'Klient - Nazwisko', 
    'Klient - Telefon',
    'Klient - Email',
    'Typ płatności',
    'Sposób dostawy',
    'Wartość zamówienia',
    'Koszt dostawy',
    'Prowizja',
    'Czas przygotowania',
    'Kod rabatowy',
    'Źródło',
    'Tenant',
    'Platforma',
    'Wersja aplikacji',
  ];

  const rows = orders.map((order) => {
    const hasSource = 'source_rel' in order;
    const sourceRel = hasSource ? (order as IOrderWithSource).source_rel : null;
    
    return [
      order.id,
      new Date(order.created_at),
      order.status,
      order.confirmation_code,
      order.restaurant ? `${order.restaurant.name} (${order.restaurant.id})` : `ID: ${order.restaurant_id}`,
      order.customer?.customer_firstname || '',
      order.customer?.customer_lastname || '',
      order.customer?.phone || '',
      order.customer?.email || '',
      order.payment_type,
      order.delivery_type,
      order.price,
      order.delivery_cost,
      order.commission,
      order.prepare_time || '',
      order.promo_code?.code || '',
      order.source,
      sourceRel?.tenant || '',
      sourceRel?.platform || '',
      sourceRel?.app_version || '',
    ];
  });

  return convertToCSV({
    headers,
    rows,
    dateFormat: 'yyyy-MM-dd HH:mm',
  });
}
